// @flow

import React from 'react';

import HeaderLogo from 'app/viewport/components/Header/HeaderLogo';
import {
  HeaderBlock,
  HeaderBlockContainer,
  HeaderBlockInnerWrapper,
  HeaderBlockMenuControls,
} from 'app/viewport/components/Header/HeaderBlock';

type Props = {
  isLoggedIn?: boolean,
};

const HeaderLogoOnly = ({ isLoggedIn }: Props) => {
  return (
    <HeaderBlock
      kind={{
        'logo-only': true,
        'logged-in': isLoggedIn,
        'logged-out': !isLoggedIn,
      }}
    >
      <HeaderBlockContainer>
        <HeaderBlockInnerWrapper kind="justify">
          <HeaderBlockMenuControls>
            <HeaderLogo isLoggedIn={isLoggedIn} />
          </HeaderBlockMenuControls>
        </HeaderBlockInnerWrapper>
      </HeaderBlockContainer>
    </HeaderBlock>
  );
};

export default HeaderLogoOnly;
